module.exports = __webpack_public_path__ + "media/images/nav_icons/dashboard-845b7d4f99f42abd8f7f7cb55bfe042e.png";